import React from "react"
import Credits from "./art/credits";
import {graphql, useStaticQuery} from "gatsby";
import Img from "gatsby-image"
import { Box } from "@chakra-ui/react";

const Visual = () => {
    const data = useStaticQuery<GatsbyTypes.WoolImageQuery>(graphql`
        query WoolImage {
            placeholderImage: file(relativePath: { eq: "wool/kagerou/49320749_p4.png" }) {
                childImageSharp {
                    fluid(maxHeight: 2160) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    if(!data?.placeholderImage?.childImageSharp?.fluid) {
        throw "Wool picture not found";
    }

    return (
        <Box flex="1 1 auto" position="relative">
            <Box position="absolute" top={0} left={0} right={0} bottom={0} overflow="hidden" >
                <Img fluid={data.placeholderImage.childImageSharp.fluid}/>
                <Credits type="image" pixiv="49320749" author="Wool"/>
            </Box>
        </Box>
    )
};

export default Visual